import React, { useState, useEffect } from 'react';
import SmartDateInput from '../ui/SmartDateInput';

const RentIncreaseForm = ({ currentRent, leaseId, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    effectiveDate: '',
    oldRent: currentRent || 0,
    newRent: currentRent || 0,
    reason: '',
    notes: ''
  });

  useEffect(() => {
    if (currentRent) {
      setFormData(prev => ({ ...prev, oldRent: currentRent, newRent: currentRent }));
    }
  }, [currentRent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const oldRentValue = Number(formData.oldRent) || 0;
  const newRentValue = Number(formData.newRent) || 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    const increaseAmount = newRentValue - oldRentValue;
    const increasePercent = oldRentValue > 0 ? ((newRentValue - oldRentValue) / oldRentValue) * 100 : 0;
    
    onSubmit({
      leaseId,
      effectiveDate: new Date(formData.effectiveDate).getTime(),
      oldRent: oldRentValue,
      newRent: newRentValue,
      increaseAmount: Math.round(increaseAmount * 100) / 100,
      increasePercent: Math.round(increasePercent * 100) / 100,
      reason: formData.reason,
      notes: formData.notes
    });
  };

  const inputClass = "w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white";
  const labelClass = "block text-xs font-medium text-slate-600 mb-1";

  const increaseAmount = newRentValue - oldRentValue;
  const increasePercent = oldRentValue > 0 ? ((newRentValue - oldRentValue) / oldRentValue) * 100 : 0;

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-slate-600">Current Rent:</span>
          <span className="text-lg font-semibold text-slate-900">${oldRentValue.toFixed(2)}/week</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-slate-600">New Rent:</span>
          <span className="text-lg font-semibold text-emerald-600">${newRentValue.toFixed(2)}/week</span>
        </div>
        <div className="mt-2 pt-2 border-t border-slate-200 flex justify-between items-center">
          <span className="text-sm text-slate-600">Increase:</span>
          <div className="text-right">
            <div className="text-sm font-medium text-emerald-600">+${increaseAmount.toFixed(2)}/week</div>
            <div className="text-xs text-slate-500">{increasePercent.toFixed(2)}%</div>
          </div>
        </div>
      </div>

      <div>
        <label className={labelClass}>Effective Date *</label>
        <SmartDateInput
          name="effectiveDate"
          value={formData.effectiveDate}
          onChange={handleChange}
          className={inputClass}
          required
        />
      </div>

      <div>
        <label className={labelClass}>New Weekly Rent Amount ($) *</label>
        <input 
          type="number" 
          name="newRent" 
          value={formData.newRent} 
          onChange={handleChange} 
          className={inputClass}
          step="0.01"
          min="0"
          required
        />
      </div>

      <div>
        <label className={labelClass}>Reason for Increase</label>
        <select name="reason" value={formData.reason} onChange={handleChange} className={inputClass}>
          <option value="">Select reason...</option>
          <option value="Market Review">Market Review</option>
          <option value="Annual Increase">Annual Increase</option>
          <option value="Property Improvements">Property Improvements</option>
          <option value="Increased Costs">Increased Costs</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div>
        <label className={labelClass}>Notes</label>
        <textarea 
          name="notes" 
          value={formData.notes || ''} 
          onChange={handleChange} 
          className={inputClass} 
          rows="3"
          placeholder="Additional details about this rent increase..."
        />
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-slate-100">
        <button type="button" onClick={onCancel} className="px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 rounded-lg">Cancel</button>
        <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 rounded-lg">Record Increase</button>
      </div>
    </form>
  );
};

export default RentIncreaseForm;